import React from 'react';
import { movdTokens } from '../design-system/movdTokens.js';

export default function Legal() {
  return (
    <main id="main-content" role="main" style={{ padding: 32, maxWidth: 700, margin: '0 auto' }}>
      <h1 style={{ margin: '0 0 24px', fontSize: 28, fontWeight: 900, color: movdTokens.color.action.primary }}>Legal</h1>
      <p style={{ marginBottom: 16, lineHeight: 1.6 }}>
        Please review our <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="/terms.html" target="_blank" rel="noopener noreferrer">Terms of Service</a> for details on how we protect your data and your rights as a user.
      </p>
      <p style={{ color: movdTokens.color.content.secondary }}>
        For legal inquiries, contact <a href="mailto:support@movd.ca">support@movd.ca</a>.
      </p>
    </main>
  );
}
